import * as React from "react";

function AppIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="110"
      height="110"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2881_226)">
        <mask
          id="mask0_2881_226"
          //   style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="110"
          height="110"
        >
          <path
            d="M85.0535 0H24.9465C11.1689 0 0 11.1689 0 24.9465V85.0535C0 98.8311 11.1689 110 24.9465 110H85.0535C98.8311 110 110 98.8311 110 85.0535V24.9465C110 11.1689 98.8311 0 85.0535 0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2881_226)">
          <path d="M110 0H0V110H110V0Z" fill="url(#paint0_linear_2881_226)" />
          <path
            d="M76.5579 32.6521C70.3629 32.6521 64.7638 35.1745 60.7169 39.2352L45.0977 54.993L60.7169 70.7509C64.7638 74.8116 70.3629 77.334 76.5579 77.334C88.8925 77.334 98.8988 67.3277 98.8988 54.993C98.8988 42.6584 88.8925 32.6521 76.5579 32.6521Z"
            fill="url(#paint1_linear_2881_226)"
          />
          <path
            d="M49.019 70.7648L33.3998 55.0069L49.019 39.2491C49.019 39.2491 49.1022 39.166 49.1576 39.1244C45.1246 35.1329 39.5809 32.666 33.4552 32.666C21.1206 32.666 11.1143 42.6723 11.1143 55.0069C11.1143 67.3416 21.1206 77.3479 33.4552 77.3479C39.5809 77.3479 45.1246 74.881 49.1576 70.8895C49.116 70.8479 49.0744 70.8064 49.0329 70.7648H49.019Z"
            fill="url(#paint2_linear_2881_226)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2881_226"
          x1="0"
          y1="55"
          x2="94.5703"
          y2="93.1994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83BCE2" />
          <stop offset="0.354709" stopColor="#6EB0D5" />
          <stop offset="0.644684" stopColor="#54A1C5" />
          <stop offset="1" stopColor="#2F8CAE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2881_226"
          x1="61.7563"
          y1="38.8056"
          x2="91.4288"
          y2="73.8692"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.03" stopColor="white" />
          <stop offset="0.18" stopColor="#F8FCFE" />
          <stop offset="0.39" stopColor="#E5F2F9" />
          <stop offset="0.64" stopColor="#C6E2F3" />
          <stop offset="0.91" stopColor="#9DCBE8" />
          <stop offset="1" stopColor="#8EC3E5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2881_226"
          x1="49.1576"
          y1="55.0069"
          x2="17.5586"
          y2="40.7369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8381B" />
          <stop offset="1" stopColor="#EC5A42" />
        </linearGradient>
        <clipPath id="clip0_2881_226">
          <rect width="110" height="110" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AppIcon;
